import React, {FC} from 'react';
import {FormNameEnum} from 'filters-selections';
import {YesNoRadioGroup} from '../YesNoRadioGroup/YesNoRadioGroup';
import {IWithDisabled} from 'models/common';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';
import {accessibilityStatusOptions} from 'admin/resources/upload/enums';

type Props = IWithDisabled;

export const CredentialingRadioGroup: FC<Props> = ({disabled}) => (
  <YesNoRadioGroup name={FormNameEnum.credentialing} label="Credentialing" disabled={disabled} />
);

export const PermissionNeededRadioGroup: FC<Props> = ({disabled}) => (
  <YesNoRadioGroup name={FormNameEnum.permissionNeeded} label="Permissions Needed" disabled={disabled} />
);

export const ReuseFlagRadioGroup: FC<Props> = ({disabled}) => (
  <YesNoRadioGroup
    name={FormNameEnum.reuseFlag}
    label="Media Rights Reuse Flag"
    disabled={disabled}
    infoText={RESOURCE_FIELD_TOOLTIPS.mediaRightsReuseFlag}
  />
);

export const AccessibilityStatusRadioGroup: FC<Props> = ({disabled}) => (
  <YesNoRadioGroup
    name={FormNameEnum.accessibilityStatus}
    label="Accessibility Status?"
    disabled={disabled}
    options={accessibilityStatusOptions}
  />
);
